import { App } from 'antd';

import { useIntl, useRequest } from '@umijs/max';

import { getLabelTemplatesAngles } from './index';

export const useGetLabelTemplatesAngles = () => {
  const intl = useIntl();
  const { message } = App.useApp();

  return useRequest(getLabelTemplatesAngles, {
    cacheKey: 'getLabelTemplatesAngles',
    onError: () => {
      message.error(intl.formatMessage({ id: 'common.fetch.failure' }));
    },
    staleTime: Infinity,
  });
};
